import React, { Component } from "react";
import { Row, Label, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import UserIcon1 from '../../../assets/user-image-plc/User_Icon_1.svg';
import UserIcon2 from '../../../assets/user-image-plc/User_Icon_2.svg';
import UserIcon3 from '../../../assets/user-image-plc/User_Icon_3.svg';
import UserIcon4 from '../../../assets/user-image-plc/User_Icon_4.svg';
import UserIcon5 from '../../../assets/user-image-plc/User_Icon_5.svg';
import './OfficeMateProfile.css';
import axios from '../../../axios';
import * as url from '../../../utils/url';
import {withRouter} from 'react-router-dom';
import NoData from '../../empty-stage/NoData/NoData'
import Spinner from '../../../assets/spinner.gif';
import { isMobile } from "../../../utils/deviceInfo";
import If from "../../../components/Shared/If";


class usersProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
        officeMate: undefined,
        profilePicSrcIndex: 0,
        noUser:false
    }
    console.log("the page PRoifiel---", this.props)
  }

  // componentDidMount(){
    
  // }

  componentWillMount() {
    // console.log("hi")
    if(this.props.location.state) {
        this.setState({officeMate: this.props.location.state.officeMate, profilePicSrcIndex: this.props.location.state.profilePicSrcIndex});
    } else {
      // console.log("profile page!!!")
      let id = this.props.match.params.id; 
      let org =this.props.match.params.orgId
      this.getUserDetails(id,org);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
   

  }


  

  navigateToOfficeMates = () => {
    console.log(this.props.history)
    this.props.history.location.pathname='/home/users'
    return
      this.props.history.location.pathname='/home/users'
      this.props.history.push('/home/users');
  }


  getUserDetails=(id,org)=> {
    axios.get(url.getUserProfile(id,org))
    .then((response) => {
      // console.log(response)
      if(response.data.data){
        this.setState({officeMate: response.data.data });
      } else {
        this.setState({noUser:true, officeMate:null})
      }
    })
  }


  renderContent = () => {
    let {firstName, lastName, title, email, dIRole, profilePic, profilePicSrcIndex} = {...this.state.officeMate};
    let offcemateName = (firstName ? firstName : '') + (lastName ? (firstName? (' '+ lastName) : lastName) : '')
    let userPicPlaceholders = [UserIcon1, UserIcon2, UserIcon3, UserIcon4, UserIcon5];
    if(this.state.officeMate && this.state.noUser!==true){
      return <div className={`${isMobile ? 'ml-3':'ml50 mt80'}`}>
      <If condition={!isMobile}>
        <div className="mt50">
        {/* <span className="officemate-name-breadcrumb">
                {offcemateName}
              </span> */}
          <Breadcrumb>
            <BreadcrumbItem>
              <a className="officemates-link" onClick={() => this.props.history.push('/home/users')}>
                Enterprise Members
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="officemate-name-breadcrumb">
                {offcemateName}
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        </If>
        
        <div className="mt30">
          <div className="row mlmr0">
            <Col sm={2} md={2} className="text-center" style={{ marginRight: '-15px', paddingLeft: '0px'}}>
              <img src={profilePic || userPicPlaceholders[this.state.profilePicSrcIndex]} className="officemate-profile-img" />
            </Col>
            <If condition={!isMobile}>
            <Col sm={10} md={10} className="officemate-profile-hrLine">
              <Row>
                <span className="officemate-name">{offcemateName}</span>
              </Row>
            </Col>
            </If>
          </div>
        </div>




        
        <div className={`row ${isMobile ? 'mt-2':' mt40'}`}>
          <Col sm={2} className={`${isMobile ? 'col-5':'text-right'}`}>
            <span className="officemate-label">Title</span>
          </Col>
          <Col sm={10} className={`align-self-center ${isMobile && 'col-7'}`}>
            <span className="officemate-value">{title}</span>
          </Col>
        </div>
        <div className={`row ${isMobile ? 'mt-2':' mt20'}`}>
          <Col sm={2} className={`${isMobile ? 'col-5':'text-right'}`}>
            <span className="officemate-label">Email</span>
          </Col>
          <Col sm={10} className={`align-self-center ${isMobile && 'col-7'}`}>
            <span className="officemate-value">{email}</span>
          </Col>
        </div>
        <div className={`row ${isMobile ? 'mt-2':' mt20'}`}>
          <Col sm={2} className={`${isMobile ? 'col-5':'text-right'}`}>
            <span className="officemate-label">DEI Role</span>
          </Col>
          <Col sm={10} className={`align-self-center ${isMobile && 'col-7'}`}>
            <span className="officemate-value">{dIRole}</span>
          </Col>
        </div>
      </div>;
    } else if(this.state.officeMate===null && this.state.noUser) {
      return <div className="ml50 mt80">
      <div className="mt50">
      <NoData {...this.props} />
      </div>
      </div>
    } else {
      return <div>
        <img src={Spinner} className="spinner-pos"/>
      </div>
    }

  }


  render() {
      // let {firstName, lastName, title, email, dIRole, profilePic, profilePicSrcIndex} = {...this.state.officeMate};
      // console.log(this.state.officeMate)
      // let offcemateName = (firstName ? firstName : '') + (lastName ? (firstName? (' '+ lastName) : lastName) : '')
      // let userPicPlaceholders = [UserIcon1, UserIcon2, UserIcon3, UserIcon4, UserIcon5];
    return this.renderContent()
  }
}


export default withRouter(usersProfile)